import { useRef, useState } from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import {
  Avatar,
  Box,
  Button,
  ButtonBase,
  Divider,
  ListItemIcon,
  ListItemText,
  MenuItem,
  Popover,
  Typography
} from '@mui/material';
import useAuth from '../../hooks/useAuth';
import CogIcon from '../../icons/Cog';
import UserIcon from '../../icons/User';
import SettingsDrawer from '../SettingsDrawer';
import { authApi } from '../../api/authApi';

const AccountPopover = () => {
  const anchorRef = useRef(null);
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [openSettings, setOpenSettings] = useState(false);
  const { hostname } = window.location;
  const tenant = hostname.split('.')[0].toUpperCase();


  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleLogout = async () => {
    try {
      handleClose();
      // va enregistrer un log de déconnexion en bdd
      await authApi.logout(user.id, localStorage.getItem('accessToken'));
      await logout();
      navigate('/');
    } catch (err) {
      console.error(err);
      toast.error('Impossible de se déconnecter.');
    }
  };

  return (
    <>
      <SettingsDrawer
        openDrawer={openSettings}
        setOpenDrawer={setOpenSettings}
      />
      <Box
        component={ButtonBase}
        onClick={handleOpen}
        ref={anchorRef}
        sx={{
          alignItems: 'center',
          display: 'flex'
        }}
      >
        <Avatar
          src={`data:image/png;base64,${user.photo}`}
          sx={{
            height: 32,
            width: 32
          }}
          
        />
      </Box>
      <Popover
        anchorEl={anchorRef.current}
        anchorOrigin={{
          horizontal: 'center',
          vertical: 'bottom'
        }}
        keepMounted
        onClose={handleClose}
        open={open}
        PaperProps={{
          sx: { width: 240 }
        }}
      >
        <Box sx={{ p: 2 }}>
          <Typography
            color="textPrimary"
            variant="subtitle2"
          >
            {user.firstname}
            {' '}
            {user.lastname}
          </Typography>
          <Typography
            color="textSecondary"
            variant="subtitle2"
          >
            {user.functions}
          </Typography>
          <Typography
            color="textSecondary"
            variant="subtitle2"
          >
            {tenant}
          </Typography>
        </Box>
        <Divider />
        <Box sx={{ mt: 2 }}>
          <MenuItem
            component={RouterLink}
            to="/dashboard/account"
          >
            <ListItemIcon>
              <UserIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText
              primary={(
                <Typography
                  color="textPrimary"
                  variant="subtitle2"
                >
                  Profil
                </Typography>
              )}
            />
          </MenuItem>
          <MenuItem>
            <ListItemIcon>
              <CogIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText
              primary={(
                <Typography
                  color="textPrimary"
                  variant="subtitle2"
                  onClick={() => { setOpenSettings(true); handleClose(); }}
                >
                  Paramètres
                </Typography>
              )}
            />
          </MenuItem>
        </Box>
        <Box sx={{ p: 2 }}>
          <Button
            color="primary"
            fullWidth
            onClick={handleLogout}
            variant="outlined"
          >
            Déconnexion
          </Button>
        </Box>
      </Popover>
    </>
  );
};

export default AccountPopover;
